import { render } from "./ImageViewerDialog.vue?vue&type=template&id=c8e8830e&scoped=true"
import script from "./ImageViewerDialog.vue?vue&type=script&lang=ts"
export * from "./ImageViewerDialog.vue?vue&type=script&lang=ts"

import "./ImageViewerDialog.vue?vue&type=style&index=0&id=c8e8830e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c8e8830e"

export default script